import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';

import { CustomSnackbarService } from '../../../services/custom-snackbar.service';
import { AuthService } from './auth.service';

/**
 * Guard to be used in routes definition, field 'canActivate'. Checks if the user has some role.
 */
@Injectable()
export class RoleGuard implements CanActivate {
  /**
   * Constructor
   * @param auth
   * @param router
   * @param snackBarService
   */
  constructor(private auth: AuthService, private router: Router, private snackBarService: CustomSnackbarService) {}

  /**
   * Check if the user has a role to access a view.
   *
   * PRECONDITION: User must be logged in -> decorators [AuthGuard, RoleGuard]
   *
   * @returns {boolean}
   */
  public canActivate(route: ActivatedRouteSnapshot): boolean {
    const allowedRoles: string[] = route.data.roles;

    const userRoles = this.auth.getUserData().roles;
    const canActivate = allowedRoles.some((allowedRole) => userRoles.includes(allowedRole));
    if (!canActivate) {
      this.snackBarService.present('Insufficient permissions');
      this.router.navigate(['login']);
    }

    return canActivate;
  }
}
